import { useMemo } from "react";
import { Link } from "react-router-dom";
import { searchTopics } from "../../manuals/schema";

function hasHit(item, hits) {
  if (!hits) return true;
  if (item.slug) return hits.has(item.slug);
  return (item.children || []).some((child) => hasHit(child, hits));
}

function TreeLinks({ items, role, activeSlug, queryHits }) {
  return (
    <ul>
      {items.filter((item) => hasHit(item, queryHits)).map((item) => {
        if (item.slug) {
          return (
            <li key={item.slug}>
              <Link className={item.slug === activeSlug ? "is-active" : ""} to={`/manuals/${role}/${item.slug}`}>
                {item.title}
              </Link>
            </li>
          );
        }
        return (
          <li key={item.title} className="manual-nav__group">
            <p>{item.title}</p>
            <TreeLinks items={item.children || []} role={role} activeSlug={activeSlug} queryHits={queryHits} />
          </li>
        );
      })}
    </ul>
  );
}

export default function ManualNav({ role, tree, activeSlug, query, onQuery }) {
  const results = useMemo(() => searchTopics(tree, query), [tree, query]);
  const searching = Boolean(query.trim());
  const hits = searching ? new Set(results.map((item) => item.slug)) : null;

  return (
    <nav className="manual-nav" aria-label="Manual topics">
      <p className="manual-nav__kicker">In this book</p>
      <label className="manual-nav__search">
        <span>Search</span>
        <input
          type="search"
          value={query}
          onChange={(event) => onQuery(event.target.value)}
          placeholder="A page, a word, an example…"
          autoComplete="off"
        />
      </label>
      {searching ? (
        <p className="manual-nav__count">
          {results.length
            ? `${results.length} matching topic${results.length === 1 ? "" : "s"}`
            : "Nothing matches yet. Try a plainer word — porch, notes, packet."}
        </p>
      ) : null}
      <TreeLinks items={tree} role={role} activeSlug={activeSlug} queryHits={hits} />
    </nav>
  );
}
